<template lang="html">
  <masked-input
    type="text"
    class="text-left form-control"
    :class="customClass"
    :id="id"
    v-model="cep"
    @change="callChange"
    @keyup="callKeyUp"
    @blur="searchCEP(cep)"
    :placeholder="placeholder"
    :mask="[/\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]"
    :guide="false"
  />
</template>

<script>
import { getCep } from '@/utils';
import MaskedInput from 'vue-text-mask';

export default {
  name: 'input-cep',
  components: {
    MaskedInput,
  },
  props: {
    placeholder: {
      type: String,
      default: '00.000-000',
    },
    model: {
      required: true,
      default: null,
    },
    id: {
      type: String,
      default: '',
    },
    state: {
      type: Boolean,
      default: null,
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    onKeyup: {
      type: Function,
      default: () => {},
    },
    updateAddress: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    cep: {
      get() {
        return this.model;
      },
      set(val) {
        this.$emit('update:model', val);
      },
    },
    customClass() {
      if (this.state === null) return null;
      const valid = this.state ? 'is-valid' : 'is-invalid';
      return valid;
    },
  },
  mounted() {
    this.cep = this.model;
  },
  methods: {
    callChange(e) {
      this.$emit('change', e.target.value);
      this.onChange(this.model);
    },
    callKeyUp() {
      this.onKeyup(this.model);
    },
    searchCEP(cep) {
      if (cep && cep.length === 10) {
        getCep(cep).then(response => {
          this.updateAddress({ city: response.localidade, state: response.uf });
        });
      }
    },
  },
};
</script>
